<script>
  import ItemResponse from "./ItemResponse.svelte";
  export let title, field;
  export let inputFocusAction;
  export let inputBlurAction;
  export let updateMultiplesHeader;
</script>

<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-form-row">
    <div class="menu-second-level">
      <i class="bi bi-card-heading me-1" />Multiples title for {field}
    </div>
  </div>
</div>
<!-- align -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="textAlign"
    token="align"
    title="Text align"
    {inputFocusAction}
    {inputBlurAction}
    value={title.align}
    changeAction={(event) => {
      updateMultiplesHeader(event, "title.align", title);
    }}
  />
</div>
<!-- font size -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="fontSize"
    token="fontSize"
    title="Font size"
    {inputFocusAction}
    {inputBlurAction}
    value={title.fontSize}
    changeAction={(event) => {
      updateMultiplesHeader(event, "title.fontSize", title);
    }}
  />
</div>
<!-- font weight -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="fontWeight"
    token="fontWeight"
    title="Font weight"
    {inputFocusAction}
    {inputBlurAction}
    value={title.fontWeight || "400"}
    changeAction={(event) => {
      updateMultiplesHeader(event, "title.fontWeight", title);
    }}
  />
</div>
<!-- color -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="color"
    token="color"
    title="Font color"
    {inputFocusAction}
    {inputBlurAction}
    value={title.color || "rgba(0,0,0,1)"}
    changeAction={(event) => {
      updateMultiplesHeader(event, "title.color", title);
    }}
  />
</div>
<!-- anchor -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="anchor"
    token="anchor"
    title="Text anchor"
    {inputFocusAction}
    {inputBlurAction}
    value={title.anchor}
    mse3pos={true}
    changeAction={(event) => {
      updateMultiplesHeader(event, "title.anchor", title);
    }}
  />
</div>
